/**
 * Created by wjjn3481 on 2017/8/2.
 */
export default {
    methods: {
        successLogin (res, isReload = false) {
            let routeData = {}
            const { needEditScoreTypeIds = [], needEntryWritePrject = [] } = res.result || {}
            this.$store.commit('APP_IN', res.result.sysConfig)
            this.$store.commit('USER_SIGN_IN', res.result.user)
            this.$store.commit('NEED_IDS', {
                needEditScoreTypeIds,
                needEntryWritePrject,
            })
            if (this.$route.query.from) {
                routeData = {path: this.$route.query.from, force: true}
            } else {
                routeData = {name: this.defaultRoute(res.result.sysConfig.menu), force: true}
            }
            if (isReload && (this.$route.name === routeData.name)) {
                this.$router.go(0)
                return true
            }
            this.$router.replace(routeData)
        },
        defaultRoute (menu) {
            let name = 'index'
            if (menu.length && menu[0].value !== name) {
                name = (menu[0].list[0] && menu[0].list[0].value) || menu[0].value
            }
            return name
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/login/switchProjectMixin.js